// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-wrapper[data-v-36f56e50] .card {\n  display: flex !important;\n  margin-bottom: 0;\n}\n@media (min-width: 768px) {\n.programs-list[data-v-36f56e50] {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n}\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
